var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { unwrapWebsiteBuilderApiData } from "./response";
const GET_SET_WEBSITE_BUILDER = "api/website-builder/settings";
const GET_WEBSITE_BUILDER_TEMPLATES = "api/website-builder/templates";
const GET_PUBLIC_WEBSITE_BUILDER_BOOTSTRAP = "/api/public/website-builder/bootstrap";
const GET_PUBLIC_WEBSITE_BUILDER_PRICING_CATALOG = "/api/public/website-builder/pricing-catalog";
const GET_COMPANY_WEBSITE_ORDER_CONFIG = "/api/public/company-websites/order-config";
const GET_COMPANY_WEBSITE_PUBLIC_STORE_SETTINGS = (storeId) => `/api/public/company-websites/stores/${storeId}`;
const GET_COMPANY_WEBSITE_PUBLIC_PICKUP_SCHEDULE = (storeId) => `/api/public/company-websites/stores/${storeId}/pickup-schedule`;
const GET_COMPANY_WEBSITE_PUBLIC_SECTIONS = "/api/public/company-websites/sections";
const GET_COMPANY_WEBSITE_PUBLIC_PRODUCT = (productId) => `/api/public/company-websites/products/${productId}`;
export const getSettings = function () {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` },
            };
            const response = yield this.axiosInstance.get(GET_SET_WEBSITE_BUILDER, config);
            return unwrapWebsiteBuilderApiData(response);
        }
        catch (error) {
            console.error("Error fetching Website Builder settings:", error);
            throw error;
        }
    });
};
export const getTemplates = function () {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` },
            };
            const response = yield this.axiosInstance.get(GET_WEBSITE_BUILDER_TEMPLATES, config);
            return unwrapWebsiteBuilderApiData(response);
        }
        catch (error) {
            console.error("Error fetching Website Builder templates:", error);
            throw error;
        }
    });
};
export const getPublicBootstrap = function () {
    return __awaiter(this, arguments, void 0, function* (params = {}) {
        try {
            const response = yield this.axiosInstance.get(GET_PUBLIC_WEBSITE_BUILDER_BOOTSTRAP, {
                params,
            });
            return unwrapWebsiteBuilderApiData(response);
        }
        catch (error) {
            console.error("Error fetching public Website Builder bootstrap:", error);
            throw error;
        }
    });
};
export const getPublicPricingCatalog = function () {
    return __awaiter(this, arguments, void 0, function* (params = {}) {
        try {
            const response = yield this.axiosInstance.get(GET_PUBLIC_WEBSITE_BUILDER_PRICING_CATALOG, {
                params,
            });
            return unwrapWebsiteBuilderApiData(response);
        }
        catch (error) {
            console.error("Error fetching public Website Builder pricing catalog:", error);
            throw error;
        }
    });
};
export const getCompanyWebsiteOrderConfig = function () {
    return __awaiter(this, arguments, void 0, function* (params = {}) {
        try {
            const response = yield this.axiosInstance.get(GET_COMPANY_WEBSITE_ORDER_CONFIG, {
                params,
            });
            return unwrapWebsiteBuilderApiData(response);
        }
        catch (error) {
            console.error("Error fetching public Company Website order config:", error);
            throw error;
        }
    });
};
export const getCompanyWebsitePublicStoreSettings = function (storeId_1) {
    return __awaiter(this, arguments, void 0, function* (storeId, params = {}) {
        try {
            const response = yield this.axiosInstance.get(GET_COMPANY_WEBSITE_PUBLIC_STORE_SETTINGS(storeId), { params });
            return unwrapWebsiteBuilderApiData(response);
        }
        catch (error) {
            console.error("Error fetching public Company Website store settings:", error);
            throw error;
        }
    });
};
export const getCompanyWebsitePublicSections = function () {
    return __awaiter(this, arguments, void 0, function* (params = {}) {
        try {
            const response = yield this.axiosInstance.get(GET_COMPANY_WEBSITE_PUBLIC_SECTIONS, {
                params,
            });
            return unwrapWebsiteBuilderApiData(response);
        }
        catch (error) {
            console.error("Error fetching public Company Website sections:", error);
            throw error;
        }
    });
};
export const getCompanyWebsitePublicProduct = function (productId_1) {
    return __awaiter(this, arguments, void 0, function* (productId, params = {}) {
        try {
            const response = yield this.axiosInstance.get(GET_COMPANY_WEBSITE_PUBLIC_PRODUCT(productId), { params });
            return unwrapWebsiteBuilderApiData(response);
        }
        catch (error) {
            console.error("Error fetching public Company Website product:", error);
            throw error;
        }
    });
};
export const getCompanyWebsitePublicPickupSchedule = function (storeId_1) {
    return __awaiter(this, arguments, void 0, function* (storeId, params = {}) {
        try {
            const response = yield this.axiosInstance.get(GET_COMPANY_WEBSITE_PUBLIC_PICKUP_SCHEDULE(storeId), { params });
            return unwrapWebsiteBuilderApiData(response);
        }
        catch (error) {
            console.error("Error fetching public Company Website pickup schedule:", error);
            throw error;
        }
    });
};
